import ViewDashboardHome from "../views/ViewDashboardHome.vue"

export default [
	{
		path: "/dashboard",
		component: ViewDashboardHome,
		name: "ViewDashboardHome",
		meta: {}
	}
]
